(function(){
  const key='anaya_wishlist';
  const get=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}};
  const set=(v)=>localStorage.setItem(key,JSON.stringify(v));
  function refresh(){
    const list=get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn=>{
      const active=list.some(item=>item.handle===btn.dataset.productHandle);
      btn.classList.toggle('is-active',active);
      btn.setAttribute('aria-pressed',String(active));
      btn.setAttribute('aria-label',`${active?'Remove':'Add'} ${btn.dataset.productTitle||'product'} ${active?'from':'to'} wishlist`);
      const textHeart=btn.querySelector('span');
      if(textHeart) textHeart.textContent=active?'♥':'♡';
    });
  }
  document.addEventListener('click',function(e){
    const btn=e.target.closest('[data-wishlist-toggle]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    let list=get();
    const item={handle:btn.dataset.productHandle,title:btn.dataset.productTitle};
    const exists=list.some(x=>x.handle===item.handle);
    if(exists){list=list.filter(x=>x.handle!==item.handle);window.AnayaToast&&window.AnayaToast('💔 Removed from wishlist','success');}
    else{list.push(item);window.AnayaToast&&window.AnayaToast('❤️ Added to wishlist','success');}
    set(list);refresh();
  });
  document.addEventListener('shopify:section:load',refresh);
  refresh();
})();
